import { useState } from "react";
import { Container } from "@mui/material";
import SubmitButton from "../buttons";
import PisService from "../../services/PisService";
import { PatientInformationSheetContent } from "./content";

interface PatientInformationSheetProps {
  // Called once the patient has accepted (server has recorded it).
  onAccepted: () => void;
}

// Patient Information Sheet (PIS) for the ADHD Remote Physical Health Monitoring pilot.
const PatientInformationSheet = ({ onAccepted }: PatientInformationSheetProps) => {
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(false);

  const accept = () => {
    setSubmitting(true);
    setError(false);
    PisService.accept()
      .then(() => onAccepted())
      .catch(() => {
        setError(true);
        setSubmitting(false);
      });
  };

  return (
    <Container style={{ marginTop: "2rem", marginBottom: "2rem", maxWidth: "800px" }}>
      <h1 className="nhsuk-heading-xl">Patient Information Leaflet</h1>
      <PatientInformationSheetContent />

      {error && (
        <p className="nhsuk-error-message" style={{ marginTop: "1rem" }}>
          Something went wrong recording your acceptance. Please try again.
        </p>
      )}

      <SubmitButton
        content={submitting ? "Please wait…" : "I understand"}
        onClick={accept}
        disabled={submitting}
        style={{ marginTop: "1rem" }}
      />
    </Container>
  );
};

export default PatientInformationSheet;
